import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LibraryV2DataService } from '../../core/services/library-v2/library-v2-data.service';
import { LibraryV2Data } from '../../core/interfaces/library-v2-data.i';
import { QrCodeService } from '../../core/services/qr-input-service/qr-input.service';
import { GlobalConstants } from '../../common/constants/global.constant';
import { MessageService } from '../../core/services/message-service/message.service';
import { GoogleAnalyticsService } from '../../core/services/google-analytics-service/google-analytics.service';
import { environment } from 'src/environments/environment';
import { Subject } from 'rxjs/internal/Subject';
import { HttpMethodsService } from 'src/app/common/utility/http-methods.service';
import { WebSocketService } from 'src/app/core/services/websocket-service/websocket.service';
import { LanguageDecode ,manufacturerMapping, manufacturerNewMapping} from 'src/app/common/constants/qrCodeMapping';
import { PromoContentService } from '../../core/services/promo-content-service/promo-content.service';

declare let gtag: Function;

@Component({
  selector: 'app-body',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  welcomeBtnText: string;
  titleText: string;
  subtitleText: string;
  libraryV2Data: LibraryV2Data;
  welcomeContent: string;
  isIntel: string;
  libraryData: any;
  isStandardEnhancement = false;
  contentTypevalue = GlobalConstants.UNKNOWN;
  isLandingPage = false;
  qrInputData: any;
  buyNowSiteLink: string = '';
  BUY_NOW_API_URL = environment?.portinoAPI;
  is2gen: boolean = false;
  private ngUnsubscribe = new Subject<boolean>();
  scannedQRInformation: any={};
  isNewAILayout: boolean = false;

  constructor(private router: Router,
    private libraryV2DataService: LibraryV2DataService,
    private qrService: QrCodeService,
    private messageService: MessageService,
    private googleAnalyticsService: GoogleAnalyticsService,
    private httpsService: HttpMethodsService,
    private webSocketService: WebSocketService,
    private promoContentService: PromoContentService) { }

  ngOnInit(): void {
    this.libraryData = this.libraryV2DataService?.getLibraryV2Data(this.qrService.qrInput.Language);
    this.titleText = this.libraryV2DataService.getStaticText('tr_welcomePageTitle');
    this.subtitleText = this.libraryV2DataService.getStaticText('tr_welcomePagetrSubtitle');
    this.welcomeBtnText = this.libraryV2DataService.getStaticText('tr_welcomePageBtnText');
    this.welcomeContent = this.libraryV2DataService.getStaticText('tr_welcomePageText');
    this.qrInputData = this.qrService?.qrInput;
    this.isIntel = this.qrInputData?.CpuManufacture;
    this.isNewAILayout = this.qrService.isNewAILayout;
    this.qrService.setBackgroundImage();
    if((this.qrInputData?.ContentType === GlobalConstants.STANDARDGEN12 ||
      this.qrInputData?.ContentType === GlobalConstants.STANDARDGEN13 ||
      this.qrInputData?.ContentType === GlobalConstants.CREATORGEN12||
      this.qrInputData?.ContentType === GlobalConstants.CREATORGEN13 ||
      this.qrInputData?.ContentType === GlobalConstants.STANDARDGEN14)) {
      this.isStandardEnhancement = true;
    }
    this.is2gen = GlobalConstants.STD_LNL_BADGES.includes(this.qrInputData?.ProcessorBadge) || GlobalConstants.ARL_STD_BADGES.includes(this.qrInputData.ProcessorBadge);
    this.messageService.islandingPage.subscribe(data => {
      this.isLandingPage = data;
    });

    if (!this.isLandingPage) {
      this.onLoadGaValues();
    }
    this.webSocketService.getbuyNowAPIData();
     if(this.qrService.vaSessionId){
     window.dispatchEvent(new CustomEvent('OPEN_IPOS_AI', {detail: this.qrService.vaSessionId}));
    }
    if(this.isNewAILayout) { 
      this.toHome();
    }
  }
  toHome() {
    const isNewAILayout = this.qrService.isNewAILayout;
    const isWildCatLakeStd = this.qrService.isWildCatLakeStd;
    if (isNewAILayout) {
      this.promoContentService.getPromoDetails(() => {
        if (this.qrService.vaSessionId) {
          this.router.navigateByUrl('/mob-content?activeTab=va');
        } else {
          if (isWildCatLakeStd) {
            this.router.navigateByUrl('/mob-content?activeTab=overview');
          } else {
            this.router.navigateByUrl('/mob-content?activeTab=onboarding');
          }
        }
      });
    } else {
      this.googleAnalyticsService.sendGtag( GlobalConstants.GET_STARTED, { event_category: GlobalConstants.GET_STARTED, event_label: 'Get Started', 'get_started': 1 });
      this.router.navigateByUrl('/mob-content');   
    }
  }

  // IIT2-5599
  contentType() {
    const iposContentType = this.qrInputData?.ContentType;
    switch(iposContentType) {
      case GlobalConstants.ATHENA_CONTENT:
      case GlobalConstants.EVO:
        this.contentTypevalue = GlobalConstants.STANDARD_TITLE;
        break;
      case GlobalConstants.CHROMEBOOKATHENA:
      case GlobalConstants.CHROMEBOOKEVO:
        this.contentTypevalue = GlobalConstants.CHROMEBOOK_TEXT;
        break;
      case GlobalConstants.NON_INTEL_TEXT:
        this.contentTypevalue = GlobalConstants.NON_INTEL_CONTENT;
        break;
      default:
        this.contentTypes(iposContentType[0]);
    }
    this.scannedQRInformation.ipos_content=this.contentTypevalue;
    this.messageService.setLandingPage(true);
    
  }

  contentTypes(iposContentType) {
    switch (iposContentType) {
      case GlobalConstants.STANDARD_TEXT:
        this.contentTypevalue = GlobalConstants.STANDARD_TITLE;
        break;
      case GlobalConstants.GAMING_CONTENT:
        this.contentTypevalue = GlobalConstants.GAMING_NAME;
        break;
      case GlobalConstants.CREATOR_CONTENT:
        this.contentTypevalue = GlobalConstants.CREATOR;
        break;
      case GlobalConstants.CHROMEBOOK:
        this.contentTypevalue = GlobalConstants.CHROMEBOOK_TEXT;
        break;
    }
  }

  onLoadGaValues() {
    this.contentType();
    this.osValue();
    this.processorGeneration();
    this.processorManufactureValue();
    this.prcessorFamily();
    this.oled();
    this.athenaEvoDevices();
    this.vproDevices();
    this.iposVersion();
    this.connectedStatus();
    this.iposLanguage();
    this.processorPlatform();
    this.oemManufacturer();    
    this.googleAnalyticsService.sendGtag(GlobalConstants.SCANNED_MOBILE_DEVICE_INFO, { event_category: GlobalConstants.SCANNED_MOBILE_DEVICE_INFO, event_label: "mobile_device_info",...this.scannedQRInformation});
    this.googleAnalyticsService.scannedParams = this.scannedQRInformation;
  }
  oemManufacturer(){
    const oemManufacturer = this.qrInputData?.SystemManufacturer.length > 1 ? manufacturerMapping[this.qrInputData?.SystemManufacturer] : manufacturerNewMapping[this.qrInputData?.SystemManufacturer];
    this.scannedQRInformation.oem_manufacturer=oemManufacturer;
  }
  processorPlatform() {
    const processorBadge = this.qrInputData?.ProcessorBadge;
    let processorPlatform;
    if(GlobalConstants.RAPTOR_LAKE.includes(processorBadge)){
      processorPlatform = GlobalConstants.RAPTOR_LAKE_PLATFORM;
    }else if(GlobalConstants.METEOR_LAKE.includes(processorBadge)){
      processorPlatform = GlobalConstants.METEOR_LAKE_PLATFORM;
    }else if(GlobalConstants.LUNAR_LAKE.includes(processorBadge)){
      processorPlatform = GlobalConstants.LUNAR_LAKE_PLATFORM;
    }else if(GlobalConstants.ARROW_LAKE.includes(processorBadge)){
      processorPlatform = GlobalConstants.ARROW_LAKE_PLATFORM;
    }else if(GlobalConstants.PANTHER_LAKE_BADGES.includes(processorBadge) || GlobalConstants.PANTHER_LAKE_12XE_BADGES.includes(processorBadge)){
      processorPlatform = GlobalConstants.PANTHER_LAKE_PLATFORM;
    }else if(GlobalConstants.WILDCAT_LAKE_BADGES.includes(processorBadge)){
      processorPlatform = GlobalConstants.WILDCAT_LAKE_PLATFORM;
    }
    this.scannedQRInformation.processor_platform = processorPlatform;
  }

  iposLanguage(){
    const iposLanguage = LanguageDecode[this.qrInputData?.Language];
    this.scannedQRInformation.ipos_language = iposLanguage;
  }

  connectedStatus(){
    const connectedStatus = this.qrInputData?.IsConnected;
    if(connectedStatus === 'y'){
      this.scannedQRInformation.connection_type=GlobalConstants.CONNECTED;
    }
    else{
      this.scannedQRInformation.connection_type=GlobalConstants.NOT_CONNECTED;
    }
  }

  iposVersion(){
    const iposVersion = this.qrInputData?.LegalVersion;
    this.scannedQRInformation.ipos_version=iposVersion;
  }


  osValue() {
    const osType = this.googleAnalyticsService.osValue();
    this.scannedQRInformation.os_name=osType;
  }

  processorManufactureValue() {
    const processorManufacture = this.qrInputData?.CpuManufacture;
    this.scannedQRInformation.processor_manufacturer=processorManufacture;
  }

  processorGeneration() {
    const processorGeneration = this.googleAnalyticsService.processorGeneration();
    this.scannedQRInformation.processor_generation=processorGeneration;
  }

  prcessorFamily() {
    const processorFamily = this.googleAnalyticsService.processorFamily();
    this.scannedQRInformation.processor_family=processorFamily;
  }

  oled () {
    if (this.qrInputData.Oled === 'Y') {
      this.scannedQRInformation.oled=GlobalConstants.SAMSUNG_OLED;
    }
    else{
      this.scannedQRInformation.oled=GlobalConstants.NON_OLED;
    }
  }

  athenaEvoDevices() {
    const iposContentType = this.qrService?.qrInput?.ContentType;
    let contentType;
    if (iposContentType === GlobalConstants.CHROMEBOOKEVO || iposContentType === GlobalConstants.EVO) { 
      contentType=GlobalConstants.EVO; 
      } else if (iposContentType === GlobalConstants.CHROMEBOOKATHENA || iposContentType === GlobalConstants.ATHENA_CONTENT) {
      contentType=GlobalConstants.ATHENA
      }
    this.scannedQRInformation.athena_evo=contentType;
  }

  vproDevices() {
    const qrInputData = this.qrService?.qrInput;
    if (GlobalConstants.vproDevices.includes(qrInputData.ProcessorBadge)) {
      this.scannedQRInformation.vpro=GlobalConstants.VPRO;
    }
  }
  
  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
